<template>
  <div>
    <el-form
      ref="form"
      :model="formData"
      size="small"
      :rules="rules"
      :disabled="disabled"
    >
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item
            :label="this.$l('form_label_cancelReason') || '取消原因'"
            prop="cancelReason"
          >
            <el-input
              type="textarea"
              :placeholder="
                this.$l('tips_input_cancelReason') || '请输入取消原因'
              "
              v-model="formData.cancelReason"
              :rows="3"
              :readonly="isAudit"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <review-table
      ref="reviewTable"
      :cancelOrderCode="cancelOrderCode"
      :orderCode="orderCode"
      :disabled="disabled"
      :isAudit="isAudit"
      :reasonVisible="reasonVisible"
      @saveOkQuestion="saveOkQuestion"
    />
  </div>
</template>
<script>
import ReviewTable from '../review-table'
import EditLoading from '@/mixins/edit-loading'
import validate from '@/libs/util.validate'
export default {
  mixins: [EditLoading],
  components: {ReviewTable},
  props: {
    disabled: Boolean,
    cancelOrderCode: String,
    orderCode: String,
    isAudit: Boolean,
  },
  data() {
    return {
      formData: {cancelReason: ''},
      reasonVisible: false,
      rules: {
        cancelReason: [
          {
            required: true,
            message: this.$l('tips_input_cancelReason') || '请输入取消原因',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.cancelOrderCode) return
      this.loadingOpen()
      this.$api
        .cancelOrderDetailApi({cancelOrderCode: this.cancelOrderCode})
        .then((res) => {
          this.loadingClose()
          this.formData = res.body
          if (this.formData.cancelReason) {
            this.reasonVisible = true
          } else {
            this.reasonVisible = false
          }
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) {
        return
      }

      this.loadingOpen()
      this.$api
        .cancelOrderEditApi({
          cancelOrderCode: this.cancelOrderCode,
          ...this.formData,
        })
        .then((res) => {
          this.loadingClose()
          const {status} = res
          if (status == 200) {
            this.$message({
              message: this.$l('INDEX.tips_save_ok') || '保存成功',
              type: 'success',
            })
            this.getData()
          }
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    saveOkQuestion() {
      this.$emit('saveOkQuestion')
    },
  },
}
</script>
<style lang="scss" scoped>
.aas {
  margin-left: 4%;
}
</style>
